import { ServiceTimeRangeCount } from '@Dashboard/Charts/ServiceTimeRangeCount';
import React from 'react';
import { useTranslation } from 'react-i18next';

import DashboardCard from '../../Layout/DashboardCard';

function VirtualAnalyzerSuspiciousObjects(props: { data: any; day: string }) {
  const { t } = useTranslation();

  return (
    <DashboardCard
      row={2}
      height="592px"
      title={t('dashboard.chart.title.virtualAnalyzerSuspiciousObjects')}
    >
      <ServiceTimeRangeCount
        data={
          props.data?.virtual_analyzerTopSuspiciousObjectsTimeline?.[props.day]
        }
        interval={props.day}
        height="520px"
      />
    </DashboardCard>
  );
}
export default React.memo(VirtualAnalyzerSuspiciousObjects);
